const context = require.context('.', false, /\.api\.js$/)

let list = {}
context.keys().forEach(key => {
  const module = context(key)
  Object.keys(module).forEach(k => {
    list[k] = module[k]
  })
})

export default list


// WEBPACK FOOTER //
// ./src/api/index.js